import { AtIcon } from '../at-icon'
import { AtLink, AtLinkProps } from '../at-link'

export interface AtIconInformativeProps {
  title?: string
  titleClass?: string
  label?: string
  labelClass?: string
  icon: string
  className?: string
  classIcon?: string
  contentClass?: string
  link?: AtLinkProps
}

export const AtIconInformative = ({
  title,
  titleClass,
  label,
  labelClass,
  icon,
  className = '',
  contentClass,
  classIcon = 'w-10 h-10 p-2 shrink-0',
  link,
}: AtIconInformativeProps) => (
  <div className={`text-neutrals-800 inline-flex gap-2 py-1 ${className}`}>
    {icon ? <AtIcon src={icon} className={classIcon} /> : null}
    <div className={`leading-1.5 ${contentClass ?? 'pt-1'}`}>
      {title && <p className={`mb-2 ${titleClass ?? ''}`}>{title}</p>}
      <p className={`text-neutrals-800 text-14 ${labelClass ?? ''}`}>{label}</p>
      {link ? (
        <p className={label ? 'text-14' : ''}>
          <AtLink {...link} />
        </p>
      ) : null}
    </div>
  </div>
)
